import React from 'react';
import { Link } from 'react-router-dom';

const MessagingDisabledPage = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '80vh',
      textAlign: 'center',
      color: '#fff',
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: '#1a3653',
        padding: '40px',
        borderRadius: '10px',
        border: '2px solid #17a398',
        maxWidth: '600px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.3)'
      }}>
        <h1 style={{ color: '#17a398', marginBottom: '20px' }}>Mensajería Deshabilitada</h1>
        <p style={{ fontSize: '1.1rem', marginBottom: '30px', lineHeight: '1.6' }}>
          La función de mensajería no está disponible para tu cuenta en este momento.
          Si crees que esto es un error, por favor contacta con el soporte técnico o tu tutor.
        </p>
        <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
          <Link 
            to="/usuario/campus" 
            className="btn"
            style={{
              backgroundColor: '#17a398',
              color: '#0d1b2a',
              padding: '10px 20px',
              textDecoration: 'none',
              borderRadius: '5px',
              fontWeight: 'bold'
            }}
          >
            Volver al Campus
          </Link>
          <a 
            href="mailto:martestgo@gmail.com"
            style={{
              border: '1px solid #17a398',
              color: '#17a398',
              padding: '10px 20px',
              textDecoration: 'none',
              borderRadius: '5px',
              fontWeight: 'bold'
            }}
          >
            Contactar Soporte
          </a>
        </div>
      </div>
    </div>
  );
};

export default MessagingDisabledPage;
